import { HandCards } from '@/components/GameAssets/PlayerController/HandCards'
import { PlayerTimer, PlayerProgressBar } from './PlayerTimer'

const Root = () => null

export const PlayerController = {
  Root,
  HandCards,
  PlayerTimer,
  PlayerProgressBar
}
